import { Component } from '@angular/core';

@Component({
  selector: 'app-sms-tos',
  templateUrl: './sms-tos.component.html'
})
export class SmsTosComponent  {

}
